import { useEffect } from "react";
import PropTypes from "prop-types";
import styles from "./CategoryHeader.css";
import CategoryHeaderDescription from "../../../CategoryHeaderDescription";
import CategoryHeaderLinks from "../../../CategoryHeaderLinks/CategoryHeaderLinks";
import CategoryHeaderTitle from "../../../CategoryHeaderTitle";
import { CATEGORY_BANNER_ID } from "../../../../constants";

export const GRID_EXPANSION_BREADCRUMB_CLASS =
  "plp-grid-expansion-four_v2-breadcrumb";

const BREADCRUMB_SELECTOR = '#chrome-breadcrumb, nav[aria-label="breadcrumbs"]';

export const CategoryHeader = ({ hasHeaderLinks, hasVisualCategories }) => {
  useEffect(() => {
    const breadcrumbElements = document.querySelectorAll(BREADCRUMB_SELECTOR);

    breadcrumbElements.forEach((breadcrumbElement) => {
      breadcrumbElement.classList.add(GRID_EXPANSION_BREADCRUMB_CLASS);
    });

    return () => {
      breadcrumbElements.forEach((breadcrumbElement) => {
        breadcrumbElement.classList.remove(GRID_EXPANSION_BREADCRUMB_CLASS);
      });
    };
  }, []);

  return (
    <section id={CATEGORY_BANNER_ID} className={styles.wrapper}>
      <div className={styles.textWrapper}>
        <div className={styles.titleHeaderWrapper}>
          <CategoryHeaderTitle hasVisualCategories={hasVisualCategories} />
          {!hasVisualCategories && (
            <CategoryHeaderDescription device="mobileOnly" />
          )}
          {hasHeaderLinks && <CategoryHeaderLinks />}
        </div>

        {!hasVisualCategories && (
          <CategoryHeaderDescription device="desktopOnly" />
        )}
      </div>
    </section>
  );
};

CategoryHeader.propTypes = {
  hasHeaderLinks: PropTypes.bool.isRequired,
  hasVisualCategories: PropTypes.bool.isRequired,
};

export default CategoryHeader;
